import { CIMSFormItemProps } from '../../CIMSFormItem/types'

/**
 * returns some common props for a {@link CIMSFormItem}
 *
 * the {@link CIMSFormItemProps.name|name} is `comment`
 *
 * @param options {@link UseGenericCommentOptions}
 * @example
 * <CIMSFormItem {...useGenericComment({ required: true })}>
 *  <CIMSComment />
 * </CIMSFormItem>
 * @example
 * <CIMSFormItem {...useGenericComment({ required: { action: 'review' } })}>
 *  <CIMSComment />
 * </CIMSFormItem>
 */
export function useGenericComment(
  options?: UseGenericCommentOptions
): Required<Pick<CIMSFormItemProps, 'label' | 'name'>> &
  Pick<CIMSFormItemProps, 'requiredMessage'> {
  const { required } = options ?? {}
  return {
    label: 'Comment',
    name: 'comment',
    requiredMessage: !required
      ? undefined
      : required === true
      ? 'Please enter a comment'
      : `Please comment on this ${required.action}`,
  }
}

export type UseGenericCommentOptions = {
  /**
   * if set to true, the {@link CIMSFormItemProps.requiredMessage|requiredMessage}
   * will be `Please enter a comment`
   *
   * otherwise, the supplied {@link action} will be used to set the message
   *
   * For example `Please comment on this ${action}`
   */
  required?:
    | boolean
    | {
        /**
         * used to set the required message
         *
         * @example 'review'
         */
        action: string
      }
}
